// Infinite marquee. Items repeated twice for a seamless loop.
export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative flex overflow-hidden ${className}`}>
      <div className="marquee-track gap-16 pr-16">
        {row.map((item, i) => (
          <div key={i} className="flex shrink-0 items-center gap-4">
            <span className="font-display text-2xl md:text-3xl font-medium tracking-tight text-white/70">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-gold" />
          </div>
        ))}
      </div>
    </div>
  );
}
